<template>
  <div :class="['select-none flex w-[80px] mt-1.5 whitespace-nowrap shadow-lg p-0 rounded-full items-center justify-center', toggle_color]">
    <ChevronLeft
      v-if="!editing_disabled"
      v-tooltip="`Toggle status left`"
      :disabled="!can_toggle_left"
      :class="[
        ` text-white dark:text-black h-5 w-5 disabled:hover:cursor-default !bg-transparent cursor-pointer disabled:hover:text-white hover:shadow-xl shadow-inner opacity-0`,
        { disabled: !can_toggle_left, 'opacity-100': can_toggle_left },
        toggle_color
      ]"
      @click.stop="() => (can_toggle_left ? toggleStatus('left') : void null)" />

    <Menu as="div" class="relative flex-1 flex-shrink-0 text-center cursor-default">
      <MenuButton
        :class="[
          `select-none  text-white dark:text-black disabled:hover:cursor-default ${'cursor-pointer'} disabled:hover:text-white hover:shadow-xl shadow-inner inline-flex w-[40px] py-1  items-center justify-center border-1 rounded-full focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue`
        ]"
        @click.stop>
        <span class="capitalize">{{ current_clause_option }}</span>
      </MenuButton>
      <transition
        v-if="!disableToggle && !editing_disabled"
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0">
        <MenuItems
          v-if="!hideDropDown"
          class="absolute z-10 mx-3 -ml-5 origin-bottom-right bg-transparent border-0 w-[80px] space-y-1 mt-1.5 focus:outline-none text-center">
          <div v-for="status in clause_options.filter((s) => s !== current_clause_option)" :key="status" class="">
            <div>
              <MenuItem v-slot="{ active }">
                <div
                  :class="[
                    active ? 'bg-gray-100 dark:bg-dark-screen-background text-gray-400' : 'text-gray-700 dark:text-dark-body-text',
                    'border bg-white dark:bg-dark-screen-background rounded-full dark:border-dark-divider-border cursor-pointer group flex items-center px-4 py-1 text-sm w-full justify-center capitalize shadow-lg'
                  ]"
                  @click.stop="switchStatus(status)">
                  {{ status }}
                </div>
              </MenuItem>
            </div>
          </div>
        </MenuItems>
      </transition>
    </Menu>
    <ChevronRight
      v-if="!editing_disabled"
      v-tooltip="`Toggle status right`"
      :disabled="!can_toggle_right"
      :class="[
        `text-white dark:text-black h-5 w-5 disabled:hover:cursor-default !bg-transparent dark:bg-dark-screen-background cursor-pointer disabled:hover:text-white hover:shadow-xl shadow-inner opacity-0`,
        { disabled: !can_toggle_right, 'opacity-100': can_toggle_right },
        toggle_color
      ]"
      tooltip="Toggle status right"
      @click.stop="() => (can_toggle_right ? toggleStatus('right') : void null)" />
  </div>
</template>

<script>
import { ChevronRight, ChevronLeft } from "lucide-vue-next"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue"
export default {
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    ChevronRight,
    ChevronLeft
  },
  inject: ["canUserEditLayout"],
  emit: ["update:currentClauseOption"],
  props: {
    currentClauseOption: {
      type: String,
      required: true
    },
    hideDropDown: {
      type: Boolean,
      required: false
    },
    disableToggle: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      current_clause_option: "All"
    }
  },
  computed: {
    editing_disabled() {
      let editing_disabled_calc = false
      if (this.$route.name == "WorkspaceItem" && this.$store.state.ui.workspace_user_access_scope == "read") {
        editing_disabled_calc = true
      }

      if (this.$route.name == "Dashboard" && this.$route.params.page) {
        const current_template = this.$store.state.portfolio.shared_layouts.find((l) => l.id == this.$route.params.page)
        if (!this.canUserEditLayout(this.$store.state.auth.user, current_template)) {
          editing_disabled_calc = true
        }
      }

      return editing_disabled_calc
    },
    can_toggle_left() {
      return !this.disableToggle && this.clause_options.findIndex((s) => s == this.current_clause_option) > 0
    },
    can_toggle_right() {
      return !this.disableToggle && this.clause_options.findIndex((s) => s == this.current_clause_option) < this.clause_options.length - 1
    },

    toggle_color() {
      return {
        All: "dark:bg-dark-light-blue bg-status-success-green",
        One: "dark:bg-dark-brand-blue bg-light-brand-blue",
        None: "bg-status-error-red dark:bg-status-warning-yellow"
      }[this.current_clause_option]
    },
    clause_options() {
      return ["All", "One", "None"]
    }
  },

  created() {
    const current_clause_option_calc =
      this.currentClauseOption == "One of" ? "One" : this.currentClauseOption == "None of" ? "None" : this.currentClauseOption
    this.current_clause_option = current_clause_option_calc
  },
  methods: {
    toggleStatus(direction) {
      let status_index = this.clause_options.findIndex((s) => s == this.current_clause_option)
      if (direction == "left") {
        status_index -= 1
      } else {
        status_index += 1
      }
      this.switchStatus(this.clause_options[status_index])
    },
    switchStatus(status) {
      this.current_clause_option = status

      this.$emit("update:currentClauseOption", this.current_clause_option)
    }
  }
}
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
